module.exports = __webpack_public_path__ + "static/media/success21.ea627e07.png";